import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../AuthContext";
import invoices from "../assets/invoices.svg";
import agreements from "../assets/agreements.svg";
import revenue from "../assets/revenue.svg";
import DealerInfo from "../sections/dealerdetails/DealerInfo";
import DealerCards from "../sections/dealerdetails/DealerCards";
import TenantsList from "../components/TenantsList";

import { getTenantByfDealerId } from "../services/tenantServices";

import { getDealerDetailsCardData } from "../services/dealerServices";
import AgreementsClaimsTabs from "../components/AgreementsClaimsTabs";
import JBWReleasaNotesDialog from "../components/JBWReleasaNotesDialog";
import { useLocation } from "react-router-dom";

const DealerDetails = () => {
  const { user, dealer, group, APP_ENV } = useContext(AuthContext);
  let urlLocation = useLocation();
  console.log("urlLocation :", urlLocation?.state?.key);
  const [activeTab, setActiveTab] = useState(0);
  const [tenantList, setTenantList] = useState([]);
  const [cardsData, setCardsData] = useState(null);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const locDealer = localStorage.getItem("dealer")
    ? JSON.parse(localStorage.getItem("dealer"))
    : null;
  console.log("Context Dealer data :", dealer);

  useEffect(() => {
    if (urlLocation?.state?.key) {
      setActiveTab(urlLocation?.state?.key);
    } else {
      setActiveTab(0);
    }
  }, [useLocation]);

  useEffect(() => {
    setSelectedDealer(locDealer);
  }, [dealer?.dealerId]);
  // useEffect(() => {
  //   setSelectedDealer((values) => JSON.parse(localStorage.getItem("dealer")));
  // }, []);
  console.log("Dealer Details dealer:", selectedDealer);
  // console.log("Dealer Details user:", user);
  const trmRef = useRef();
  const onSync = () => {
    trmRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const getTenants = () => {
    console.log("loading tenant list");
    setTenantList([]);
    setSelectedTenant(null);
    getTenantByfDealerId(selectedDealer.dealerId)
      .then(
        (res) => {
          console.log("getTenantByfDealerId response  :", res);
          const data = res.data;
          if (data && data.length > 0) {
            if (
              selectedDealer.tenantId &&
              selectedDealer.tenantId !== "undefined" &&
              selectedDealer.tenantId?.length > 0
            ) {
              // console.log("adding tenants filter : ",dealer.tenants)
              setTenantList(
                data.filter((dt) => selectedDealer.tenantId?.includes(dt.tenantId))
              );
            } else {
              // console.log("Setting Tenant list not dealer tenants :",data);
              setTenantList(data);
            }
          }
        },
        (err) => {
          console.log("Unable retrive tenats data", err);
        }
      )
      .catch((err) => {
        console.error("tenant service Error :", err);
      });
  };

  const getCardsData = () => {
    getDealerDetailsCardData(selectedDealer.dealerId)
      .then(
        (res) => {
          console.log("cards data :", res);
          const data = APP_ENV === "Development" ? res.data.body : res.data;
          const statusCode = res.status;
          if (statusCode === 200 && data.length > 0) {
            setCardsData(data[0]);
          }
        },
        (err) => {
          console.log("Unable retrive cards data", err);
        }
      )
      .catch((err) => {
        console.error("CardsData service Error :", err);
      });
  };

  useEffect(() => {
    if (selectedDealer) {
      getTenants();
      getCardsData();
    }
  }, [selectedDealer?.dealerId]);

  const handleSelectedTenant = (param) => {
    setSelectedTenant(param);
  };
  const handleRestTenant = () => {
    console.log("reset tenant called");
    setSelectedTenant(null);
    getTenants();
  };

  return (
    <Box component="main">
      <Container maxWidth="xl" spacing={1}>
        {!selectedDealer ? (
          <Box>
            <Typography component="h3" variant="h3">
              Dealer Is required
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} lg={6}>
              <DealerInfo
                dealer={selectedDealer}
                user={user}
                onSync={onSync}
                sx={{ maxWidth: "100%", height: "90%", borderRadius: "10px" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <DealerCards
                value={
                  cardsData?.totalInvoicesProcessed
                    ? cardsData?.totalInvoicesProcessed
                    : 0
                }
                imgsrc={invoices}
                titletxt={"Total Invoices Processed"}
                sx={{ maxWidth: "100%", height: "90%", borderRadius: "10px" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <DealerCards
                value={
                  cardsData?.agreementsCreated
                    ? cardsData?.agreementsCreated
                    : 0
                }
                imgsrc={agreements}
                titletxt={"Agreements Created"}
                sx={{ maxWidth: "100%", height: "90%", borderRadius: "10px" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <DealerCards
                value={
                  cardsData?.totalClaims ? `${cardsData?.totalClaims}` : `0`
                }
                imgsrc={revenue}
                titletxt={"Claims Created"}
                sx={{ maxWidth: "100%", height: "90%", borderRadius: "10px" }}
              />
            </Grid>
            {!["workiz", "sera"].includes(
              selectedDealer.crmSystem?.toLowerCase()
            ) && (
                <Grid item xs={12} sm={12} lg={12}>
                  <TenantsList
                    tenantList={tenantList}
                    updateTenantsList={getTenants}
                    onSelectedTenant={handleSelectedTenant}
                    onRestTenant={handleRestTenant}
                  />
                </Grid>
              )}
            <Grid item xs={12} sm={12} lg={12}>
              {/* <AgreementList displayType="dealers" dealer={selectedDealer} /> */}
              {/* {selectedDealer && ( */}
              <AgreementsClaimsTabs
                displayType="dealers"
                dealer={selectedDealer}
                showDealer={false}
                tenant={selectedTenant}
                activeTab={activeTab}
              />
              {/* )} */}
            </Grid>
            {/* <Grid item xs={12} sm={12} lg={12} ref={trmRef}>
              <TransmissionDetailsList
                displayType="dealers"
                dealer={selectedDealer}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={6} lg={3} ref={trmRef}>
              <TransmissionDetails />
            </Grid> */}
            {group === "jbw-dealer" && <JBWReleasaNotesDialog />}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default DealerDetails;
